import { PktButton } from '@/components/button/Button'
import { PktHeader, Representing, User, UserMenuItem } from '@/components/header/Header'
import { PktLink } from '@/components/link/Link'

export default function Header() {
  function openMenu() {
    console.log('Åpner meny')
  }

  function logOut() {
    console.log('Logger ut')
  }

  function changeRepresentation() {
    console.log('Bytter representasjon')
  }

  function userMenuItemFunction() {
    console.log('Mine adresser')
  }

  function logoClick() {
    console.log('Logo klikket')
  }

  function handleSearch(query: string) {
    console.log('Søker etter:', query)
  }

  const user: User = {
    name: 'Aksel Web Opdahl',
    shortname: 'AWO',
    lastLoggedIn: new Date(),
  }

  const representing: Representing = {
    name: 'Joe & the Juice Norge AS',
    shortname: 'JJN',
    orgNumber: '911738066',
  }

  const userMenu: UserMenuItem[] = [
    {
      title: 'Mine bookinger',
      iconName: 'heart',
      target: '#',
    },
    {
      title: 'Mine adresser',
      iconName: 'house-heart',
      target: userMenuItemFunction,
    },
    {
      title: 'Innstillinger',
      iconName: 'cogwheel',
      target: '#',
    },
  ]

  const linkAndButtonContent = (
    <>
      <PktLink href="https://www.oslo.kommune.no">Lenke</PktLink>
      <PktLink href="https://www.oslo.kommune.no">Lenke</PktLink>
      <PktButton skin="secondary">Knapp</PktButton>
    </>
  )
  return (
    <main className="page-main pkt-container">
      <h1>Header</h1>
      <p>
        <a href="/header-full">Test denne komponenten på sin egen side for å teste posisjon og scroll</a>
      </p>

      <section className="component">
        <h2>Grunnleggende</h2>
        <h3>Uten tjenestenavn</h3>
        <div className="component__block-example">
          <PktHeader position="relative" scrollBehavior="none" />
        </div>

        <h3>Med tjenestenavn</h3>
        <div className="component__block-example">
          <PktHeader position="relative" scrollBehavior="none" serviceName="Gravferdsetaten" />
        </div>

        <h3>Med tjenestenavn og tjenestelenke</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            serviceLink="https://www.oslo.kommune.no"
          />
        </div>

        <h3>Med logolenke (funksjon)</h3>
        <div className="component__block-example">
          <PktHeader position="relative" scrollBehavior="none" serviceName="Gravferdsetaten" logoClick={logoClick} />
        </div>

        <h3>Skjult logo</h3>
        <div className="component__block-example">
          <PktHeader position="relative" scrollBehavior="none" serviceName="Gravferdsetaten" hideLogo={true} />
        </div>
      </section>

      <section className="component">
        <h2>Kompakt modus</h2>
        <h3>Standard</h3>
        <p>laptop (1280px ~): 104 px, tablet-up (1024px ~): 88 px, mobile (0px ~ 767px): 72 px</p>
        <div className="component__block-example">
          <PktHeader position="relative" scrollBehavior="none" serviceName="Gravferdsetaten" />
        </div>

        <h3>Compact</h3>
        <p>laptop (1280px ~): 72 px, tablet-up (1024px ~): 64 px, mobile (0px ~ 767px): 64 px</p>
        <div className="component__block-example">
          <PktHeader position="relative" scrollBehavior="none" serviceName="Gravferdsetaten" compact={true} />
        </div>
      </section>

      <section className="component">
        <h2>Slot innhold (children)</h2>
        <h3>Med lenker og knapper</h3>
        <div className="component__block-example">
          <PktHeader position="relative" scrollBehavior="none" serviceName="Gravferdsetaten">
            {linkAndButtonContent}
          </PktHeader>
        </div>

        <h3>Med bruker, lenker og knapper</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            user={user}
            userMenu={userMenu}
            logOut={logOut}
          >
            {linkAndButtonContent}
          </PktHeader>
        </div>
      </section>

      <section className="component">
        <h2>Søk</h2>
        <h3>Med søkefelt</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            showSearch={true}
            onSearch={handleSearch}
            searchPlaceholder="Søk i tjenester..."
          />
        </div>

        <h3>Med søkefelt og bruker</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            showSearch={true}
            onSearch={handleSearch}
            user={user}
            userMenu={userMenu}
            logOut={logOut}
          />
        </div>
      </section>

      <section className="component">
        <h2>Logg ut-knapp plassering</h2>
        <h3>I header (logOutButtonPlacement="header")</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            user={user}
            userMenu={userMenu}
            logOutButtonPlacement="header"
            logOut={logOut}
          />
        </div>

        <h3>I brukermeny (logOutButtonPlacement="userMenu")</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            user={user}
            userMenu={userMenu}
            logOutButtonPlacement="userMenu"
            logOut={logOut}
          />
        </div>

        <h3>Begge steder (logOutButtonPlacement="both")</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            user={user}
            userMenu={userMenu}
            logOutButtonPlacement="both"
            logOut={logOut}
          />
        </div>
      </section>

      <section className="component">
        <h2>Logget inn som privatperson</h2>
        <h3>Kan ikke endre representasjon</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            canChangeRepresentation={false}
            user={user}
            userMenu={userMenu}
            logOut={logOut}
            serviceName="Gravferdsetaten"
          />
        </div>

        <h3>Kan endre representasjon</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            canChangeRepresentation={true}
            user={user}
            userMenu={userMenu}
            changeRepresentation={changeRepresentation}
            logOut={logOut}
            serviceName="Gravferdsetaten"
          />
        </div>
      </section>

      <section className="component">
        <h2>Representerer en virksomhet</h2>
        <h3>Kan ikke endre representasjon</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            canChangeRepresentation={false}
            representing={representing}
            user={user}
            userMenu={userMenu}
            logOut={logOut}
            serviceName="Gravferdsetaten"
          />
        </div>

        <h3>Kan endre representasjon</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            canChangeRepresentation={true}
            representing={representing}
            user={user}
            userMenu={userMenu}
            changeRepresentation={changeRepresentation}
            logOut={logOut}
            serviceName="Gravferdsetaten"
          />
        </div>
      </section>

      <section className="component">
        <h2>Lange navn</h2>
        <h3>Langt brukernavn og representant</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Etaten for store og små ting"
            user={{ ...user, name: 'Aksel Thao Karlsen Nguyen Mohammed Veldig langt navn' }}
            representing={{
              ...representing,
              name: 'Joe & the Juice Norge AS Joe & the Juice Norge AS Veldig langt navn',
            }}
            userMenu={userMenu}
            logOutButtonPlacement="userMenu"
            logOut={logOut}
          />
        </div>
      </section>

      <section className="component">
        <h2>Custom breakpoints</h2>
        <h3>Breakpoint: tablet (768px)</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            mobileBreakpoint={768}
            tabletBreakpoint={1280}
            user={user}
            userMenu={userMenu}
            logOut={logOut}
          >
            {linkAndButtonContent}
          </PktHeader>
        </div>

        <h3>Breakpoint: laptop (1280px)</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            mobileBreakpoint={1280}
            tabletBreakpoint={1600}
            compact={true}
            user={user}
            userMenu={userMenu}
            logOut={logOut}
          >
            {linkAndButtonContent}
          </PktHeader>
        </div>
      </section>

      <section className="component">
        <h2>Alt kombinert</h2>
        <h3>Alle funksjoner i bruk</h3>
        <div className="component__block-example">
          <PktHeader
            position="relative"
            scrollBehavior="none"
            serviceName="Gravferdsetaten"
            serviceLink="https://www.oslo.kommune.no"
            compact={true}
            user={user}
            representing={representing}
            userMenu={userMenu}
            canChangeRepresentation={true}
            changeRepresentation={changeRepresentation}
            logOutButtonPlacement="both"
            logOut={logOut}
            showSearch={true}
            onSearch={handleSearch}
            searchPlaceholder="Søk..."
          >
            {linkAndButtonContent}
          </PktHeader>
        </div>
      </section>
    </main>
  )
}
